import Keycloak from 'keycloak-js';

// Keycloak
const initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID,
  onLoad: 'login-required',
};

const keycloak = Keycloak(initOptions);

export { keycloak, initOptions };
